// extracted by mini-css-extract-plugin
module.exports = {"totaliser":"jgp-YFqdJ","cancelled":"jgp-AW6xt","totals":"jgp-2Vgbx"};